export interface PurchaseEntryItem {
  key: "store" | "amazon" | "link";
  label: string;
  url: string;
  action?: "orderNow";
}

export interface PurchaseEntryConfig {
  locales: string[];
  homeHeaderItems?: PurchaseEntryItem[];
  homeBannerItems?: PurchaseEntryItem[];
  productHeaderItems?: PurchaseEntryItem[];
}

const AM_INFINITY_97_HOME_HEADER_STORE_ITEM: PurchaseEntryItem = {
  key: "store",
  label: "Official Store",
  url:
    "https://store.angrymiao.com/?utm_source=website&utm_medium=owned&utm_campaign=header_cta"
};

const AM_INFINITY_97_STORE_ITEM: PurchaseEntryItem = {
  key: "store",
  label: "Official Store",
  url:
    "https://store.angrymiao.com/products/am-infinity-97-wireless-gaming-mouse"
};

// const AM_INFINITY_97_AMAZON_PRODUCT_ITEM: PurchaseEntryItem = {
//   key: "amazon",
//   label: "Buy On Amazon",
//   url:
//     "https://www.amazon.com/dp/B0H46YXQHK?maas=maas_adg_CB8D27372937F415DBE7950A16156CAA_afap_abs&ref_=aa_maas&tag=maas&th=1"
// };

const AM_INFINITY_97_AMAZON_STORE_ITEM: PurchaseEntryItem = {
  key: "amazon",
  label: "Buy On Amazon",
  // url:
  //   "https://www.amazon.com/stores/AngryMiao/page/AC8161A0-5FEA-445C-9AAB-32F441ED8BC5?lp_asin=B0H46QF79Z&ref_=ast_bln&store_ref=bl_ast_dp_brandlogo_sto"
  url:
    "https://www.amazon.com/dp/B0H46YXQHK?maas=maas_adg_109FF5FD9CF60C5FD5DDE65C8E70C10F_afap_abs&ref_=aa_maas&tag=maas&th=1"
};

// const AM_INFINITY_97_AMAZON_BANNER_ITEM: PurchaseEntryItem = {
//   ...AM_INFINITY_97_AMAZON_PRODUCT_ITEM,
//   label: "Amazon"
// };

const AM_INFINITY_97_HOME_HEADER_ITEMS: PurchaseEntryItem[] = [
  AM_INFINITY_97_HOME_HEADER_STORE_ITEM,
  AM_INFINITY_97_AMAZON_STORE_ITEM
];

const AM_INFINITY_97_HOME_BANNER_ITEMS: PurchaseEntryItem[] = [
  AM_INFINITY_97_STORE_ITEM
  // , AM_INFINITY_97_AMAZON_BANNER_ITEM
];

const AM_INFINITY_97_PRODUCT_HEADER_ITEMS: PurchaseEntryItem[] = [
  AM_INFINITY_97_STORE_ITEM
  // , AM_INFINITY_97_AMAZON_PRODUCT_ITEM
];

const BE745_DOG_TAG_HOME_BANNER_ITEMS: PurchaseEntryItem[] = [
  {
    key: "link",
    label: "了解更多",
    url: "https://dry---studio.com/cn/battleye-r2/"
  },
  {
    key: "store",
    label: "高玩认证",
    url: "https://battleyer2-verify.angrymiao.com"
  }
];

const purchaseEntryConfigs: Record<string, PurchaseEntryConfig> = {
  "AM INFINITY 97": {
    locales: ["en"],
    homeHeaderItems: AM_INFINITY_97_HOME_HEADER_ITEMS,
    homeBannerItems: AM_INFINITY_97_HOME_BANNER_ITEMS,
    productHeaderItems: AM_INFINITY_97_PRODUCT_HEADER_ITEMS
  },
  "BE745 DOG TAG": {
    locales: ["cn"],
    homeBannerItems: BE745_DOG_TAG_HOME_BANNER_ITEMS
  }
};

function supportsLocale(code: string, locale: string): boolean {
  const config = purchaseEntryConfigs[code];
  return !!config && config.locales.includes(locale);
}

export function getHomeHeaderPurchaseEntry(locale: string) {
  const code = "AM INFINITY 97";
  if (!supportsLocale(code, locale)) {
    return null;
  }
  return purchaseEntryConfigs[code].homeHeaderItems || null;
}

export function getHomeBannerPurchaseEntry(code: string, locale: string) {
  if (!supportsLocale(code, locale)) {
    return null;
  }
  return purchaseEntryConfigs[code].homeBannerItems || null;
}

export function getProductHeaderPurchaseEntry(code: string, locale: string) {
  if (!supportsLocale(code, locale)) {
    return null;
  }
  return purchaseEntryConfigs[code].productHeaderItems || null;
}
